import { useMemo } from 'react';

import { CustomAsyncSelectOption } from 'modules/_shared/components/CustomAsyncSelect/types/CustomAsyncSelectOption';

type UseGetMaxSharesToTransfer = {
  partnerActualSharesCount: number;
  selectedHoldingClassOption: CustomAsyncSelectOption | null;
};

export const useGetMaxSharesToTransfer = ({
  partnerActualSharesCount,
  selectedHoldingClassOption,
}: UseGetMaxSharesToTransfer) => {
  const maxSharesToTransfer = useMemo(() => {
    if (!selectedHoldingClassOption) return partnerActualSharesCount;

    const holdingClassSharesCount =
      (selectedHoldingClassOption?.sharesCount as number) || 0;

    return Math.min(partnerActualSharesCount, holdingClassSharesCount);
  }, [partnerActualSharesCount, selectedHoldingClassOption]);

  return {
    data: { maxSharesToTransfer },
  };
};
